import Box from "@/components/Box";
import { CollapseableText } from "@/components/CollapseableText";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

const ReportInformationPanel = ({ title, body, onClick, diagram }) => {
  return (
    <Stack
      bg="white"
      borderRadius={20}
      pt={[40, 40, 60]}
      pb={[60, 60, 80]}
      px={[24, 24, 40]}
      maxWidth={1152}
      mx="auto"
      gap={40}
    >
      <Stack gap={16}>
        <Box fontFamily="gilroyBold" fontSize={[32, 32, 44]} lineHeight={["36px", "36px", "50px"]}>
          {title}
        </Box>
        <CollapseableText
          richText
          maxLines={8}
          fontFamily="gilroyMedium"
          fontSize={[14, 14, 16]}
          lineHeight={1.75}
        >
          {body}
        </CollapseableText>
      </Stack>
      {diagram ? (
        <ButtonV2 color="dark" withChevron onClick={onClick} sx={{ mr: "auto" }}>
          View diagram
        </ButtonV2>
      ) : null}
    </Stack>
  );
};

export default ReportInformationPanel;
